import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Checkbox,
  FormControlLabel,
  Divider,
  Button,
  Stack,
  CircularProgress
} from "@mui/material";

import api from "../../api/api";
import { ENDPOINTS } from "../../api/endpoints";
import Navbar from "../NavigationTalent";
import Footer from "../../Footer";

export default function Notifications() {
  const userId = Number(localStorage.getItem("userId"));

  /* ------------------------------
     State
  ------------------------------ */

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [settings, setSettings] = useState({
    removeFromPublicSearch: false,
    removeFromSearchEmails: false,
    removeFromResumeViewedEmails: false
  });

  /* ------------------------------
     Fetch existing settings
  ------------------------------ */

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await api.get(
          ENDPOINTS.GET_USER_PRIVACY_SETTINGS,
          { params: { userId } }
        );

        const data = res?.data?.data || {};

        setSettings({
          removeFromPublicSearch: !!data.isPublicSearchOptOut,
          removeFromSearchEmails: !!data.isSearchEmailOptOut,
          removeFromResumeViewedEmails: !!data.isResumeViewedEmailOptOut
        });
      } catch (err) {
        console.error("Failed to load privacy settings", err);
      } finally {
        setLoading(false);
      }
    };

    if (userId) fetchSettings();
  }, [userId]);

  /* ------------------------------
     Handlers
  ------------------------------ */

  const handleChange = (key) => (event) => {
    setSettings((prev) => ({
      ...prev,
      [key]: event.target.checked
    }));
  };

  const handleSave = async () => {
    try {
      setSaving(true);

      await api.post(
        ENDPOINTS.SAVE_USER_PRIVACY_SETTINGS,
        {
          userId,
          isPublicSearchOptOut: settings.removeFromPublicSearch,
          isSearchEmailOptOut: settings.removeFromSearchEmails,
          isResumeViewedEmailOptOut:
            settings.removeFromResumeViewedEmails
        }
      );
    } catch (err) {
      console.error("Failed to save privacy settings", err);
    } finally {
      setSaving(false);
    }
  };

  /* ------------------------------
     UI
  ------------------------------ */

  if (loading) {
    return (
      <>
        <Navbar />
        <Box display="flex" justifyContent="center" mt={6}>
          <CircularProgress />
        </Box>
      </>
    );
  }

  return (
    <>
      <Navbar />

      <Box maxWidth="800px" mx="auto" mt={4}>
        <Typography variant="h5" fontWeight={600} gutterBottom>
          Notifications & Privacy
        </Typography>

        {/* ---------------- Privacy Section ---------------- */}
        <Paper elevation={1} sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" fontWeight={600} gutterBottom>
            Privacy
          </Typography>

          <FormControlLabel
            control={
              <Checkbox
                checked={settings.removeFromPublicSearch}
                onChange={handleChange("removeFromPublicSearch")}
              />
            }
            label={
              <Typography>
                Remove me from public searches
                <Typography component="span" color="text.secondary">
                  {" "}
                  (This excludes verified casting account searches)
                </Typography>
              </Typography>
            }
          />
        </Paper>

        {/* ---------------- Email Notifications Section ---------------- */}
 {/*        <Paper elevation={1} sx={{ p: 3 }}>
          <Typography variant="h6" fontWeight={600} gutterBottom>
            Email Notifications
          </Typography>

          <Stack spacing={1}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={settings.removeFromSearchEmails}
                  onChange={handleChange("removeFromSearchEmails")}
                />
              }
              label="Remove me from: You’ve appeared in a search emails"
            />

            <Divider />

            <FormControlLabel
              control={
                <Checkbox
                  checked={settings.removeFromResumeViewedEmails}
                  onChange={handleChange("removeFromResumeViewedEmails")}
                />
              }
              label="Remove me from: Your resume has been viewed"
            />
          </Stack>
        </Paper>
 */}
        {/* ---------------- Save Button ---------------- */}
        <Box display="flex" justifyContent="flex-end" mt={3}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? "Saving..." : "Save Settings"}
          </Button>
        </Box>
      </Box>
      <Footer />
    </>
  );
}
